import React, { useEffect, useState } from 'react';
import {
    Card, CardContent, TextField, Button, IconButton, Avatar, Box, Typography, Grid,
    Divider
} from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import profile_image from "../../../Assets/Media.jpg"
import { VscHeart } from "react-icons/vsc";
import { FaHeart } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import FullPageLoader from '../../../Components/FullPageLoader/FullPageLoader';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Form, Formik } from 'formik';
import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
import { adminUrl } from '../../../constants';
import EmojiPickerComponent from '../../../Components/EmojiPickerComponent/EmojiPickerComponent';
import CustomInputWithEmoji from '../../../Components/CustomInputLogin/CustomInputWithEmoji';
import PostJobViewModal from '../PostJobs/PostJob/PostJobViewModal';
import PostInternshipViewModal from '../PostJobs/PostInternship/PostInternshipViewModal';
import { commentOnFeedAction } from '../../../ReduxStore/Slices/Post/commentOnFeed';

const UserCard = ({ userData, handleConnectButton }) => (

    <Card
        sx={{
            // borderRadius: 3,
            boxShadow: 2
        }}>
        <CardContent
            sx={{
                boxShadow: 'none',
                '& .MuiCard-root': {
                    boxShadow: 'none',
                },
            }}
        >

            <Grid
                container
                spacing={4}
                sx={{ p: 2 }}
                alignItems="center" justifyContent="space-between" flexDirection={{ xs: "column", md: "row", sm: "column" }}>
                <Grid
                    item size={{ md: 4 }} sx={{ display: "flex", paddingTop: "0px", justifyContent: "center", flexDirection: "column" }}>
                    <Avatar
                        sx={{ width: 70, height: 70 }}
                        src={userData?.profileImage}
                    // src={image}

                    >
                        {/* <Box
                            component="img"
                            src={userData?.image} sx={{ width: 70, height: 70, objectFit: "contain" }}
                        >

                        </Box> */}
                    </Avatar>

                </Grid>
                <Grid item size={{ md: 8 }} sx textAlign={{ xs: "center", md: "start", sm: "center", paddingTop: "0px", }}>
                    <Typography variant="h6" fontWeight={600}>{userData?.name}</Typography>
                    <Typography variant="body1">{userData?.course}</Typography>
                    <Typography variant="body1">@{userData?.campus}</Typography>
                    <Typography variant="body1">{userData?.batch}</Typography>



                </Grid>
                <Button
                    onClick={() => {
                        handleConnectButton(userData?.connect_userId)
                    }}
                    variant="contained"
                    color="primary"
                    fullWidth
                    // startIcon={<VideoCall style={{ fontSize: "12px" }} />}
                    sx={{
                        fontSize: "14px",
                        textTransform: "none",
                        mr: "2px",
                        color: "white",
                        background: "var(--main-color)",
                        // borderRadius: "20px",
                        padding: "5px 9px",
                        boxShadow: "none"
                    }}
                >
                    Connect
                </Button>
            </Grid>
        </CardContent>
    </Card>
);


const SearchBox = () => {
    const [postText, setPostText] = useState('');
    const [imagePreview, setImagePreview] = useState(null);
    const [posts, setPosts] = useState([]);
    const searchActive = useSelector((state) => state.search.searchActive);
    console.log(posts, "postsssssssssssss")
    const [replyingToIndex, setReplyingToIndex] = useState(null);
    console.log(postText, "postText")
    console.log(imagePreview, "postText 1")

    const { getUserById } = useSelector(state => state?.getUserById);


    const { MyPostForusers } = useSelector(state => state?.MyPostForusers);
    const { MyPostForUsersGetAll } = useSelector(state => state?.MyPostForUsersGetAll);
    console.log(MyPostForusers, "postsForUserpostsForUser 22")

    console.log(MyPostForUsersGetAll, "postsForUserpostsForUser 11")

    const [uploadedFiles, setUploadedFiles] = useState([])
    console.log(uploadedFiles, 'uploadedFiless')
    console.log(uploadedFiles?.length, 'uploadedFiles couunt')
    console.log(uploadedFiles[0]?.type, 'uploadedFiles type')




    // user id get rom sesstion storage
    const sessionUserId = sessionStorage.getItem("userId")
    console.log(sessionUserId, "sessionUserId")

    const [selectedFiles, setSelectedFiles] = useState([])

    const handleImageUpload = async (e) => {
        const files = Array.from(e.target.files); // All selected files

        if (files.length === 0) return;

        const updatedFiles = [...selectedFiles, ...files];
        setSelectedFiles(updatedFiles);

        const formData = new FormData();

        updatedFiles.forEach((file) => {
            formData.append("uploadFiles", file); // same key used multiple times
        });

        const data1 = {
            data: formData,
            method: "post",
            apiName: "multiplefiles",
        };

        try {
            const response = await dispatch(actions.UPLOADPDFILEPOST(data1));
            console.log(response, "uploadPdfAndImageResponse");
            setUploadedFiles(response?.payload?.data?.files);
        } catch (error) {
            console.error("Upload failed:", error);
        }
    };


    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);

    const alumni_user_id = sessionStorage.getItem("alumni_user_id")
    const blobUrlToFile = async (blobUrl, fileName) => {
        const response = await fetch(blobUrl);
        const blob = await response.blob();
        return new File([blob], fileName, { type: blob.type });
    };



    // useEffect(() => {
    //   // const tempArr = [];
    //   const fetchData = async () => {
    //     const data1 = {
    //       data: {},
    //       method: "get",
    //       apiName: `mypost/${alumni_user_id}`,
    //     };
    //     dispatch(actions.MYPOSTFORUSERGETALL(data1));

    //   }
    //   fetchData()
    // }, [MyPostForusers]);


    const { createFeed } = useSelector(
        (state) => state?.createFeed
    );

    const { likeFeed } = useSelector(
        (state) => state?.likeFeed
    );

    const { unlikeFeed } = useSelector(
        (state) => state?.unlikeFeed
    );

    const { getCommentsWithReplies } = useSelector(
        (state) => state?.getCommentsWithReplies
    );

    const { getFeedLikedUsers } = useSelector(
        (state) => state?.getFeedLikedUsers
    );

    console.log(getFeedLikedUsers, "getFeedLikedUsers")



    const { getUserAndConnectionsFeedsWithLikeWithComment } = useSelector(
        (state) => state?.getUserAndConnectionsFeedsWithLikeWithComment
    );


    const { globalSearch } = useSelector(
        (state) => state?.globalSearch
    );

    const handlePost = async (values) => {
        console.log(values, "valuessssss")

        console.log(uploadedFiles, "uploadedFilesssssss")
        const data1 = {
            data: {
                // text:"4343434"
                user_id: sessionUserId,
                content: { text: values?.postText },
                media: uploadedFiles

            },
            method: "post",
            apiName: `createFeed`,
            // isFormData: true,
        };

        const responseData = await dispatch(actions.CREATEFEED(data1));
        console.log(responseData, "responseData")
        console.log(responseData, "responseDtata")
        if (responseData?.payload?.message === "Feed posted successfully.") {
            setLoading(false);
            console.log("itswork")
            // resetForm()
            // resetForm();
            // setUploadedFile([]); // Assuming this manages UI state
            // handleAddFormGoBackButton();
            // setTimeout(() => {
            toast.success(`Post added successfully.`)
            setSelectedFiles([])
            setUploadedFiles([]);

            // }, 1500);
        } else {
            setLoading(false);
            toast.error(responseData?.payload?.message);
        }


        const newPost = {
            id: Date.now(),
            text: postText,
            image: imagePreview,
            likes: 0,
            comments: [],
            showCommentBox: false,
        };
        setPosts([newPost, ...posts]); // Add new post at the top
        setPostText('');
        setImagePreview(null);
    };



    const { commentOnFeed } = useSelector(
        (state) => state?.commentOnFeed
    );


    const { replyToComment } = useSelector(
        (state) => state?.replyToComment
    );


    //get all post api integration

    useEffect(() => {

        const fetchData = async () => {
            //   const data1 = {
            //     data: {},
            //     method: "get",
            //     apiName: `getUserAndConnectionsFeedsWithLikeWithComment/${sessionUserId}`,
            //   };
            //   const response = await dispatch(actions.GETUSERANDCONNECTIONSFEEDSWITHLIKEWITHCOMMENT(data1));

            //   console.log(response, "responseresponse")

            if (globalSearch?.data?.primary_filter === "feed") {


                const allPostData = globalSearch?.data?.results?.map((data) => ({
                    id: data?.feed_id,
                    user_id: data?.user_id,
                    text: data?.content?.text,
                    feed_type: data?.content?.feed_type,
                    type_id: data?.content?.type_id,
                    media: data?.media,
                    postUserData: data?.user,
                    likeCount: data?.likeCount,
                    commentCount: data?.commentCount,
                    isLiked: data?.isLiked,
                    showCommentBox: false,
                    showLikeBox: false
                }))
                setPosts(allPostData)
            }

            if (globalSearch?.data?.primary_filter === "users") {
                const allPostData2 = globalSearch?.data?.results?.map((data) => ({
                    connect_userId: data?.user_id,
                    name: `${data?.first_name} ${data?.last_name}`,
                    course: data?.course,
                    campus: data?.campus,
                    profileImage: data?.profileImage,
                    batch: data?.batch
                }))

                setPosts(allPostData2)
            }


        }
        fetchData()


    }, [createFeed, likeFeed, unlikeFeed, commentOnFeed, replyToComment, searchActive])


    const settings = {
        dots: true,
        // infinite: true,
        speed: 500,
        height: 450,
        slidesToShow: 1,
        slidesToScroll: 1
    };



    // const handleLike = (postId) => {
    //   setPosts(posts.map(post =>
    //     post.id === postId ? { ...post, likes: post.likes + 1 } : post
    //   ));
    // };


    // const [posts, setPosts] = useState([
    //   { id: 1, likes: 0 },
    //   { id: 2, likes: 5 },
    //   // ...other posts
    // ]);
    const [likedPosts, setLikedPosts] = useState([]); // track liked post IDs


    const handleLikePost = async (feed_id, isLiked) => {
        // console.log(id, "idddddddddd")
        if (!isLiked) {
            const data1 = {
                data: {
                    user_id: sessionUserId
                },
                method: "post",
                apiName: `likeFeed/${feed_id}`,
            };
            const response = await dispatch(actions.LIKEFEED(data1));
            console.log(response, "responsedataaaaaaa")
        } else {
            const data1 = {
                data: {
                    user_id: sessionUserId
                },
                method: "delete",
                apiName: `unlikeFeed/${feed_id}`,
            };
            const response = await dispatch(actions.UNLIKEFEED(data1));
            console.log(response, "responsedataaaaaaa")

        }
    }

    const handleLike = (postId) => {
        if (!likedPosts.includes(postId)) {
            setPosts(posts.map(post =>
                post.id === postId ? { ...post, likes: post.likes + 1 } : post
            ));
            setLikedPosts([...likedPosts, postId]); // add to liked posts
        }
    };

    // show comments
    const [isShowCommment, setShowcomment] = useState(false)
    const handleGetCommentsDetails = async (feed_id) => {
        const data1 = {
            data: {},
            method: "get",
            apiName: `getCommentsWithReplies/${feed_id}`,
        };
        const response = await dispatch(actions.GETCOMMENTSWITHREPLIES(data1));
        console.log(response, "responsedataaaaaaa")
    }

    const handleGetLikeDetails = async (feed_id) => {
        const data1 = {
            data: {},
            method: "get",
            apiName: `getFeedLikedUsers/${feed_id}`,
        };
        const response = await dispatch(actions.GETFEEDLIKEDUSERS(data1));
        console.log(response, "responsedataaaaaaa")
    }


    // const toggleCommentBox = (feed_id) => {
    //   setShowcomment(!isShowCommment)


    //   if (!isShowCommment) {
    //     handleGetCommentsDetails(feed_id)

    //     // setPosts(posts.map(post =>
    //     //   post.id === postId ? { ...post, showCommentBox: !post.showCommentBox } : post
    //     // ));
    //   };
    // }


    // const toggleCommentBox = (feed_id) => {
    //   setPosts((prevPosts) =>
    //     prevPosts.map((post) => {
    //       if (post.id === feed_id) {
    //         if (!post.showCommentBox) {
    //           handleGetCommentsDetails(feed_id);
    //         }
    //         return {
    //           ...post,
    //           showCommentBox: !post.showCommentBox,
    //         };
    //       }
    //       return post;
    //     })
    //   );
    // };


    const toggleLikeBox = (feed_id) => {
        console.log(feed_id, "feed_idfeed_idfeed_idfeed_id")
        const updatedPosts = posts.map((post) => {
            if (post.id === feed_id) {
                if (!post.showLikeBox) {
                    handleGetLikeDetails(feed_id); // fetch comments only when opening
                }
                return { ...post, showLikeBox: !post.showLikeBox };
            } else {
                return { ...post, showLikeBox: false }; // close all other comment boxes
            }
        });

        setPosts(updatedPosts);
    };


    const toggleCommentBox = (feed_id) => {
        const updatedPosts = posts.map((post) => {
            if (post.id === feed_id) {
                if (!post.showCommentBox) {
                    handleGetCommentsDetails(feed_id); // fetch comments only when opening
                }
                return { ...post, showCommentBox: !post.showCommentBox };
            } else {
                return { ...post, showCommentBox: false }; // close all other comment boxes
            }
        });

        setPosts(updatedPosts);
    };
    // const handleAddComment = (postId, commentText) => {
    //   setPosts(posts.map(post =>
    //     post.id === postId
    //       ? { ...post, comments: [...post.comments, commentText] }
    //       : post
    //   ));
    // };

    const handleAddComment = async (feed_id, commentText, parentIndex = null) => {
        const data1 = {
            data: {
                user_id: sessionUserId,
                content: commentText

            },

            method: "post",
            apiName: `commentOnFeed/${feed_id}`,
        };
        const response = await dispatch(actions.COMMENTONFEED(data1));
        console.log(response, "responsedataaaaaaa")
        if (response?.payload?.message === "Comment posted.") {
            handleGetCommentsDetails(feed_id)

        }



        // setPosts(posts.map(post => {
        //   if (post.id !== postId) return post;

        //   if (parentIndex === null) {
        //     // Add new top-level comment
        //     return {
        //       ...post,
        //       comments: [...post.comments, { text: commentText, profile_image: profile_image, replies: [] }]
        //     };
        //   } else {
        //     // Add reply to existing comment
        //     const updatedComments = [...post.comments];
        //     updatedComments[parentIndex].replies.push(commentText);
        //     return {
        //       ...post,
        //       comments: updatedComments
        //     };
        //   }
        // }));
    };

    const handleReplyComment = async (feed_id, comment_id, commentText, parentIndex = null) => {
        const data1 = {
            data: {
                user_id: sessionUserId,
                content: commentText

            },

            method: "post",

            apiName: `feeds/${feed_id}/comment/${comment_id}/reply`,
        };
        const response = await dispatch(actions.REPLYTOCOMMENT(data1));
        console.log(response, "responsedataaaaaaa")
        if (response?.payload?.message === "Reply posted.") {
            handleGetCommentsDetails(feed_id)

        }
    }


    // const images = post?.image?.images || [];
    // const videos = post?.image?.videos || [];
    // const documents = post?.image?.documents || [];

    // const totalMediaCount = images.length + videos.length + documents.length;
    const [visibleReplies, setVisibleReplies] = useState([]);


    const toggleReplies = (idx) => {
        setVisibleReplies((prev) =>
            prev.includes(idx)
                ? prev.filter((i) => i !== idx) // hide replies
                : [...prev, idx] // show replies
        );
    };

    const [viewJobModalOpen, setViewJobModalOpen] = useState(false)
    const handleViewJobModalOpen = () => {
        setViewJobModalOpen(true)
    }
    const handleViewJobModalClose = () => {
        setViewJobModalOpen(false)
    }



    const [viewInternshipModalOpen, setViewInternshipModalOpen] = useState(false)
    const handleViewInternshipModalOpen = () => {
        setViewInternshipModalOpen(true)
    }
    const handleViewInternshipModalClose = () => {
        setViewInternshipModalOpen(false)
    }



    const handleJobViewDetails = async (id, feed_type) => {
        if (feed_type === "jobpost") {

            const data1 = {
                data: {},
                method: "get",
                apiName: `getJobById/${id}`,
            };
            const response = await dispatch(actions.GETJOBBYID(data1));
            handleViewJobModalOpen()
        } else if (feed_type === "internshippost") {

            const data1 = {
                data: {},
                method: "get",
                apiName: `getInternshipById/${id}`,
            };
            const response = await dispatch(actions.GETINTERNSHIPBYID(data1));
            handleViewInternshipModalOpen()
        }

    }

    const handleConnectButton = async (connect_userId) => {
        console.log(connect_userId, "userrrrrrrrr")
        const data1 = {
            data: {
                sender_id: Number(sessionUserId),
                receiver_id: Number(connect_userId)
            },
            method: "post",
            apiName: `sendConnectionRequest`,
        };
        const response = await dispatch(actions.SENDCONNECTIONREQUEST(data1));
        console.log(response, "responsedataaaaaaa")
        if (response?.payload?.message === "Connection request sent.") {
            toast?.success('Connection request sent successfully!')
        } else {
            toast.error(response?.payload?.message)
        }


    }


    return (
        <Box sx={{ margin: 'auto', mt: 2, boxShadow: 4 }}>
            {/* <EmojiPickerComponent /> */}
            {/* Input Box */}
            {loading && <FullPageLoader />}


            {globalSearch?.data?.primary_filter === "feed" ? ((posts.length > 0 ? (posts?.map((post, index) => (
                <Card key={post.id} sx={{ mt: 2, borderRadius: 2 }}>
                    <CardContent>
                        <Box display="flex" alignItems="center" gap={1} mb={1}>
                            <Avatar src={`${adminUrl}${post?.postUserData?.profileImage}`}
                                sx={{
                                    border: "1px solid gray",
                                    "& .MuiAvatar-img": {
                                        objectFit: "contain"
                                    }
                                }} />
                            <Typography fontWeight={550} variant='subtitle1'>{post?.postUserData?.first_name} {post?.postUserData?.last_name}</Typography>
                        </Box>
                        <Divider />


                        <Typography variant="body1" sx={{ color: "black", p: "10px 0px" }}>{post?.text}</Typography>
                        {post?.feed_type &&
                            <Typography variant='body1' sx={{ color: "var(--main-color)", cursor: "pointer" }} onClick={() => {
                                handleJobViewDetails(post?.type_id, post?.feed_type)
                            }}>
                                View details
                            </Typography>
                        }


                        {((post?.media?.length === 1) ? (

                            <Box p={1} sx={{ border: "1px solid #ded7d7" }}>
                                {post?.media?.map((file) => (
                                    file?.fileType === "image" ? (
                                        <>
                                            <img
                                                src={`${adminUrl}${file?.fileUrl}`}
                                                alt="Not support"
                                                width="100%"
                                                style={{ borderRadius: 8, maxHeight: 450 }}
                                            />
                                        </>
                                    ) : file?.fileType === "video" ? (
                                        <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
                                            <source
                                                // src={URL.createObjectURL(uploadedFiles[0])} type={uploadedFiles[0]?.type}
                                                // src={post?.image?.videos[0]?.url_path}

                                                src={`${adminUrl}${file?.fileUrl}`}
                                            />
                                            Your browser does not support the video tag.
                                        </video>

                                    ) : file?.fileType === "pdf" ? (
                                        <>
                                            <iframe
                                                // src={post?.image?.documents[0]?.url_path}
                                                src={`${adminUrl}${file?.fileUrl}`}

                                                width="100%"
                                                style={{ borderRadius: 8, height: 450 }}
                                            />
                                        </>
                                    ) : null
                                ))}
                            </Box>

                        ) : (

                            <Box mt={1}>
                                <Slider {...settings}>
                                    {post?.media?.map((file) => (
                                        file?.fileType === "image" ? (
                                            <>
                                                <img
                                                    src={`${adminUrl}${file?.fileUrl}`}
                                                    alt="Not support"
                                                    width="100%"
                                                    style={{ borderRadius: 8, maxHeight: 450 }}
                                                />
                                            </>
                                        ) : file?.fileType === "video" ? (
                                            <video controls width="100%" style={{ borderRadius: 8, maxHeight: 450 }}>
                                                <source
                                                    // src={URL.createObjectURL(uploadedFiles[0])} type={uploadedFiles[0]?.type}
                                                    // src={post?.image?.videos[0]?.url_path}

                                                    src={`${adminUrl}${file?.fileUrl}`}
                                                />
                                                Your browser does not support the video tag.
                                            </video>

                                        ) : file?.fileType === "pdf" ? (
                                            <>
                                                <iframe
                                                    // src={post?.image?.documents[0]?.url_path}
                                                    src={`${adminUrl}${file?.fileUrl}`}

                                                    width="100%"
                                                    style={{ borderRadius: 8, height: 450 }}
                                                />
                                            </>
                                        ) : null
                                    ))}
                                </Slider>
                            </Box>

                        ))}



                        <Box mt={2} display="flex" gap={2} alignItems="center">
                            <Box
                                sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                            >


                                <Box
                                    onClick={() => handleLikePost(post?.id, post?.isLiked)}

                                >

                                    {post?.isLiked ? (
                                        <FaHeart style={{ fontSize: "20px", color: "red" }} />
                                    ) : (
                                        <VscHeart style={{ fontSize: "20px" }} />
                                    )}
                                </Box>
                                &nbsp;
                                {/* <IconButton
                    sx={{ fontSize: "16px", color: "inherit" }}
                    // onClick={() => handleLike(post.id)}
                    // onClick={() => handleLikePost(post?.id, post?.isLiked)}



                  > */}
                                <Box onClick={() => {
                                    toggleLikeBox(post?.id)
                                }}>
                                    <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "500 !important", color: "black" }}>{post?.likeCount} Like</Typography>
                                    {/* </IconButton> */}
                                </Box>
                            </Box>
                            <IconButton sx={{ fontSize: "16px" }} onClick={() => toggleCommentBox(post?.id)}>
                                <ChatBubbleOutlineOutlinedIcon style={{ fontSize: "20px" }} />&nbsp;
                                <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "500 !important", color: "black" }}>{post?.commentCount} Comment </Typography>
                            </IconButton>
                        </Box>
                        {post?.showLikeBox && (
                            <Box>
                                <Divider />

                                <Typography variant='body1' sx={{ mt: 2, color: "black" }}>All Likes</Typography>

                                {getFeedLikedUsers?.data?.map((likeUser, index) => (
                                    <>

                                        <Box display="flex" alignItems="center" gap={1} mb="4px" mt="10px" key={index}>
                                            <Avatar src={`${adminUrl}${likeUser?.profileImage}`}
                                                sx={{
                                                    border: "1px solid gray",
                                                    "& .MuiAvatar-img": {
                                                        objectFit: "contain"
                                                    }
                                                }} />
                                            <Box>
                                                <Typography variant='subtitle2' color="black" >{likeUser?.first_name} {likeUser?.last_name}</Typography>
                                                {/* <Typography variant="body1" sx={{ color: "black" }}>{getFeedLikedUsers?.content}</Typography> */}
                                            </Box>
                                        </Box>
                                    </>
                                ))}
                            </Box>
                        )}

                        {post?.showCommentBox && (
                            <Box mt={2}>
                                {/* Main comment input */}
                                <TextField
                                    key={index}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    placeholder="Write a comment..."
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && e.target.value.trim() !== '') {
                                            handleAddComment(post.id, e.target.value, index);
                                            e.target.value = '';
                                        }
                                    }}
                                />

                                {/* Display comments */}
                                {getCommentsWithReplies?.data?.length > 0 && (

                                    <Box mt={2}>
                                        {getCommentsWithReplies?.data?.map((comment, idx) => (
                                            <Box key={idx} ml={1} mt={2}>
                                                <Box>
                                                    <Box display="flex" alignItems="center" gap={1} mb="4px">
                                                        <Avatar src={`${adminUrl}${comment?.User?.profileImage}`}
                                                            sx={{
                                                                border: "1px solid gray",
                                                                "& .MuiAvatar-img": {
                                                                    objectFit: "contain"
                                                                }
                                                            }} />
                                                        <Box>
                                                            <Typography variant='subtitle2' color="black" >{comment?.User?.first_name} {comment?.User?.last_name}</Typography>
                                                            <Typography variant="body1" sx={{ color: "black" }}>{comment?.content}</Typography>
                                                        </Box>
                                                    </Box>

                                                    {/* Reply clickable text */}

                                                    <Box sx={{ display: "flex", ml: 6 }}>
                                                        <Typography
                                                            variant="body1"
                                                            sx={{ cursor: 'pointer', mr: 2, fontSize: "12px", color: 'var(--main-color)', }}
                                                            onClick={() => setReplyingToIndex(idx)}
                                                        >
                                                            Reply
                                                        </Typography>

                                                        {comment?.Replies.length > 0 && (

                                                            < Typography
                                                                variant="body1"
                                                                sx={{ color: 'var(--main-color)', cursor: 'pointer', fontSize: "12px" }}
                                                                onClick={() => toggleReplies(idx)}
                                                            >
                                                                {visibleReplies.includes(idx) ? 'Hide replies' : 'Show replies'}
                                                            </Typography>
                                                        )}

                                                    </Box>
                                                </Box>

                                                {/* Replies */}
                                                {/* {comment?.Replies.length > 0 && ( */}
                                                {
                                                    visibleReplies.includes(idx) && comment?.Replies.length > 0 && (
                                                        <Box ml={5} mt={2}>
                                                            {comment?.Replies?.map((reply, rIdx) => (
                                                                <Box display="flex" alignItems="center" gap={1} mb={2}>
                                                                    <Avatar src={`${adminUrl}${reply?.User?.profileImage}`}
                                                                        sx={{
                                                                            border: "1px solid gray",
                                                                            "& .MuiAvatar-img": {
                                                                                objectFit: "contain"
                                                                            }
                                                                        }} />
                                                                    <Box>
                                                                        <Typography variant='subtitle2' color="black">{reply?.User?.first_name} {reply?.User?.last_name}</Typography>
                                                                        <Typography variant="body1" sx={{ color: "black" }}>{reply?.content}</Typography>
                                                                    </Box>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    )
                                                }

                                                {/* Show reply input if replyingToIndex === current comment index */}
                                                {replyingToIndex === idx && (
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        placeholder="Reply..."
                                                        fullWidth
                                                        sx={{ mt: 1 }}
                                                        autoFocus
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' && e.target.value.trim() !== '') {
                                                                handleReplyComment(comment?.feed_id, comment?.comment_id, e.target.value, idx);
                                                                e.target.value = '';
                                                                setReplyingToIndex(null); // hide input after replying
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                            </Box>
                        )}


                    </CardContent>
                </Card>
            ))) : (
                <Typography variant="h6" sx={{ textAlign: "center", width: "100%", mt: 2, p: 3 }}>
                    No post found.
                </Typography>
            ))) : (globalSearch?.data?.primary_filter === "users" ? (posts.length > 0 ? (
                <Grid container spacing={2}>

                    {posts.map((userData, index) => (
                        <Grid item size={{ xs: 12, sm: 6, md: 6 }} key={index} mb={3}>
                            <UserCard userData={userData} handleConnectButton={handleConnectButton} />
                        </Grid>
                    ))} 
                </Grid>
            ) : (
                <Typography variant="h6" sx={{ textAlign: "center", width: "100%", mt: 2, p: 3 }}>
                    No user found.
                </Typography>
            )) : <></>)}



            <PostJobViewModal
                open={viewJobModalOpen}
                onClose={handleViewJobModalClose}
            />
            <PostInternshipViewModal
                open={viewInternshipModalOpen}
                onClose={handleViewInternshipModalClose}
            />
        </Box >
    );
};

export default SearchBox;
